export default __webpack_public_path__ + "static/media/quie-step-4.0de16e90.svg";